import PageLayout from "examples/LayoutContainers/PageLayout";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import Loader from "examples/Loader";
import Pricing from "./Pricing";
import Tabs from "../components/Tabs";
import CreateModal from "./components/CreateModal/index";
import { useAppServices } from "hook/services";
import SettingINFO from "./SettingINFO";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import PageTitle from "../components/PageTitle";
import PrimaryButton from "../components/PrimaryButton";
import "./plansCompact.css";
import Coupens from "./Coupens";

function Saas() {
  const [Load, setLoad] = useState(0);
  const AppService = useAppServices();
  const [products, setproducts] = useState([]);
  const [potentialproducts, setpotentialproducts] = useState([]);
  const { knowledgeBase, loading } = useKnowledgeBase();
  const [agency] = useAgencyInfo();
  const [open, setOpen] = useState(false);
  const [prices, setPrices] = useState([]);

  const onLoad = () => {
    getProducts();
    getPotentialProducts();
    setLoad(false);
  };

  const getProducts = async () => {
    const { response } = await AppService.saas.agencysaas({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response) {
      setproducts(response?.data);
    } else {
    }
  };
  const getPotentialProducts = async () => {
    const { response } = await AppService.saas.potentialproducts({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response) {
      setpotentialproducts(response);
    } else {
    }
  };
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <>
      {Load ? (
        <Loader />
      ) : (
        <>
          <style>
            {`
       .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}

`}
          </style>
          <PageLayout>
            <div className="sd-plans sd-page">
            <div
              style={{ width: "100%", position: "relative" }}
              className="sd-page__header d-flex justify-content-between"
            >
              <PageTitle helpUrl={!loading && knowledgeBase?.plans}>Plans</PageTitle>
              <div
                style={{
                  width: "50%",
                  marginTop: "105px",
                  textAlign: "right",
                  textAlign: "right",
                  position: "absolute",
                  right: 13,
                }}
              >
                <div className="d-flex justify-content-end">
                  <PrimaryButton type="button" showPlus onClick={() => setOpen(true)}>
                    Add Plan
                  </PrimaryButton>
                  {open && (
                    <CreateModal
                      open={open}
                      onClose={() => setOpen(false)}
                      prices={prices}
                      handleRefresh={onLoad}
                      data={products}
                    />
                  )}
                </div>
              </div>
            </div>
            <Tabs
              tabsData={[
                {
                  label: "Price and planing",
                  content: (
                    <Pricing
                      data={products}
                      potentialproducts={potentialproducts}
                      handleRefresh={onLoad}
                    />
                  ),
                },
                { label: "Advanced Settings", content: <SettingINFO /> },
                { label: "Coupons", content: <Coupens /> },
              ]}
            />
            </div>
          </PageLayout>
        </>
      )}
    </>
  );
}

export default Saas;